import Fuse from 'fuse.js';
import type { Issue, Card } from '../types';

const fuseOptions = {
  keys: ['title', 'tags', 'whatItLooksLike', 'causes', 'problem', 'cause', 'fix'],
  threshold: 0.4,
  includeScore: true
};

export function createIssueSearcher(issues: Issue[]) {
  return new Fuse(issues, {
    ...fuseOptions,
    keys: ['title', 'tags', 'whatItLooksLike', 'causes', 'fixes']
  });
}

export function createCardSearcher(cards: Card[]) {
  return new Fuse(cards, fuseOptions);
}

export function searchIssues(issues: Issue[], query: string): Issue[] {
  if (!query.trim()) return issues;
  const fuse = createIssueSearcher(issues);
  return fuse.search(query).map(result => result.item);
}

export function searchCards(cards: Card[], query: string): Card[] {
  if (!query.trim()) return cards;
  const fuse = createCardSearcher(cards);
  return fuse.search(query).map(result => result.item);
}

export function filterIssues(
  issues: Issue[],
  filters: {
    category?: string;
    severity?: string;
    printerType?: string;
  }
): Issue[] {
  return issues.filter(issue => {
    if (filters.category && issue.category !== filters.category) return false;
    if (filters.severity && issue.severity !== filters.severity) return false;
    if (filters.printerType && !issue.printerType.includes(filters.printerType)) return false;
    return true;
  });
}
